import { selectSlotRecipe as kdsSelectSlotRecipe } from '@kintsugi/ui/recipes';

/**
 * KDS Select recipe with admin’s pre-migration outline restored.
 * KDS paints the field border on `control` (trigger is borderless); map the
 * old trigger colors there — neutral.100 at rest, brand.500 when expanded —
 * and keep `l1` radii on control/content so dropdowns match prior admin UI.
 */
export const selectSlotRecipe = {
  ...kdsSelectSlotRecipe,
  base: {
    ...kdsSelectSlotRecipe.base,
    control: {
      ...kdsSelectSlotRecipe.base?.control,
      borderRadius: 'l1',
      borderColor: 'neutral.100',
      _hover: {
        borderColor: 'neutral.100',
      },
      '&:has([aria-expanded=true])': {
        borderColor: 'brand.500',
      },
    },
    trigger: {
      ...kdsSelectSlotRecipe.base?.trigger,
      borderRadius: 'l1',
    },
    content: {
      ...kdsSelectSlotRecipe.base?.content,
      borderRadius: 'l1',
    },
  },
};
